<script setup>
import { computed } from 'vue'

import { CHECKIN_FIELDS_IDS } from '@/utils/check-ins/check-ins'
import { CHECKIN_ENTITY_KEYS } from '@/utils/entity-keys'

import CheckinChangedProgress from '@/components/objectives/element-check-in/CheckinChangedProgress'
import CheckinChangedStatus from '@/components/objectives/element-check-in/CheckinChangedStatus'
import CheckinChangedValue from '@/components/objectives/element-check-in/CheckinChangedValue'
import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'CheckinChangedParameterResolver'
})

const props = defineProps({
  parameter: {
    type: Object,
    required: true
  },

  okrElement: {
    type: Object,
    default: () => ({})
  }
})

const PARAMETER_COMPONENTS = {
  [CHECKIN_FIELDS_IDS.STATUS]: CheckinChangedStatus,
  [CHECKIN_FIELDS_IDS.PROGRESS]: CheckinChangedProgress,
  [CHECKIN_FIELDS_IDS.VALUE]: CheckinChangedValue
}

const resolvedComponent = computed(() => {
  return PARAMETER_COMPONENTS[props.parameter[CHECKIN_ENTITY_KEYS.PARAMETER_ID]] || null
})
</script>

<template>
  <AppIcon
    v-if="parameter[CHECKIN_ENTITY_KEYS.NAME] === CHECKIN_ENTITY_KEYS.ARROW"
    class="ccp-Arrow"
    height="24"
    icon-name="arrow-right-next"
    width="24"
  />

  <component
    :is="resolvedComponent"
    v-else-if="resolvedComponent"
    :data="parameter[CHECKIN_ENTITY_KEYS.DATA]"
    :okr-element
  />
</template>

<style lang="scss" scoped>
.ccp-Arrow {
  color: $dark-2;
}
</style>
